import Vue from 'vue';
import staticPagesMixin from './static-pages-mixin';

import MainVue from './main-vue';
import { setItemSessionStorage } from './helper-functions/services';
import planSummary from './view-specific/quote-results/plan-summary';


new MainVue({
    el: '#app',
    mixins: [staticPagesMixin],
    components: {
        'plan-summary': planSummary, // only in misc-landing-page AND company-plan-pages
    },
    data() {
        return {
            mapUrl: '',
            plansToView: null,
            fVisaPlans: ibJS.fVisa || null,
            jVisaPlans: ibJS.jVisa || null,
            displaySelectedView: null,
        }
    },
    created() {
        if(!window.ibJS.imageUrl && window.ibJS.address) {  
            let address = window.ibJS.address;
            if(window.ibJS.state && window.ibJS.city) {
                address += ', ' + window.ibJS.city + ', ' + window.ibJS.state;
            }
            this.getMapDetails(address);
        }
        
        if(navigator.cookieEnabled && window.ibJS.isSchoolEligibility && sessionStorage) {
            setItemSessionStorage('schoolLandingPageId', window.ibJS.schoolCode);
        }
    },
    mounted() {
        this.plansToView = this.defaultPlansToView(); 
        if(window.globalLanguage) {
           this.displaySelectedView = window.globalLanguage[this.defaultPlansToView()];
        }
    },
    watch: {
        plansToView: function(newval) {   
            this.displaySelectedView = newval === 'fVisa' ? window.globalLanguage.fVisa : window.globalLanguage.jVisa;
            if (navigator.cookieEnabled) {
                sessionStorage.setItem('plansToView', newval);
            }
        },
    },
    methods:{
        getMapDetails (address) {  
            address = address.replace(/\s/g,'+').toLowerCase();
            // this.noAddress = true;
            this.$http.get('https://nominatim.openstreetmap.org/search?q='+address+'&format=json&polygon=1&addressdetails=1').then(res =>{
                const responseBody = res.body;
                if (responseBody && Array.isArray(responseBody) && responseBody.length) {
                    const latlong = responseBody[0].boundingbox || [];
                    const mlon = responseBody[0].lon || '';
                    const mlat = responseBody[0].lat || '';
                    if (latlong && latlong.length === 4) {
                        this.mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${latlong[2]}%2C${latlong[0]}%2C${latlong[3]}%2C${latlong[1]}&layer=mapnik&marker=${mlat}%2C${mlon}`;
                        // this.noAddress = false;
                    }
                }
            })
            .catch(error => {
                console.error(error);
            });
        },
        defaultPlansToView: function() {   
            /* Give priority to sessionStorage */
            if(navigator.cookieEnabled && sessionStorage.getItem('plansToView') && sessionStorage.getItem('plansToView').indexOf('Visa') !== -1) {
                return sessionStorage.getItem('plansToView')
            } else {
                /* show jVisa by default only if fvisa is empty and jvisa is not. else show fVisa. */
                return (ibJS.jVisa && ibJS.jVisa.length > 0) || ibJS.jVisaNoPlans ? 'jVisa' : ibJS.fVisa && ibJS.fVisa.length > 0 ? 'fVisa' : 'jVisa'
            }
        },
    }
})